import { gate } from 'hub-http/gates';
export const DEVELOPER_TEST_HUB_TYPE = 8;
export const QA_SURVEY_ID = 333;
export const PROD_SURVEY_ID = 363;
export const GATES = {
  FAVORITE_PU_GATE: gate('ProductUpdates:FavoritePU'),
  NEW_TO_YOU_GATE: gate('ProductUpdates:NewToYou'),
  PM_OUTREACH_GATE: gate('ProductUpdates:PmOutreach')
};
export const SCOPES = {
  SLOW_ROLLOUT: 'slow-rollout-access',
  BETA_ADMIN_ACCESS: 'beta-admin-access'
};